/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function PremiumNotification(props) {
    return (
        <SvgIcon {...props}>
            <polygon points="6.5,1 8.51,4.951 13,5.584 9.75,8.659 10.518,13 6.5,10.951 2.483,13 3.25,8.659 0,5.584 4.491,4.951" />
        </SvgIcon>
    );
}

PremiumNotification.defaultProps = {
    viewBox: '0 0 12 16'
};

export default PremiumNotification;
